import script from "./ComplianceRateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplianceRateCard.vue?vue&type=script&setup=true&lang=js"

import "./ComplianceRateCard.vue?vue&type=style&index=0&id=bd644998&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd644998"]])

export default __exports__